import { TableColumnsType } from "antd";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { CommonTable } from "components/atoms/table/AntdTable";
import AddLyveModal from "./add/AddLyveModal";
import ViewLyveModal from "./view/ViewLyveModal";
import {
  CUMULUS_TYPE,
  LicenseDetailData,
} from "api/interfaces/subscription.interface";

type Props = {
  queryInfo: BasePagination;
  columns: TableColumnsType<LicenseDetailData>;
  data: Array<LicenseDetailData>;
  onChangePage: (page: number, totalRows: number) => void;
  isLoading: boolean;
  isAddModal: boolean;
  isEditModal: boolean;
  onModal: (type: string, row?: LicenseDetailData) => void;
  selectRow: LicenseDetailData | undefined;
  refetch: () => void;
  onChangePartNumber: (option: string) => void;
  updatedKey: string;
  type: CUMULUS_TYPE;
};

export default function LyvePresenter({
  queryInfo,
  columns,
  data,
  onChangePage,
  isLoading,
  isAddModal,
  isEditModal,
  onModal,
  selectRow,
  refetch,
  onChangePartNumber,
  updatedKey,
  type,
}: Props) {
  return (
    <>
      <CommonTable
        columns={columns}
        dataSource={data}
        queryInfo={queryInfo}
        onChangePage={onChangePage}
        loading={isLoading}
      />
      {isAddModal && (
        <AddLyveModal
          onModal={() => onModal("add")}
          refetch={refetch}
          type={type}
        />
      )}
      {isEditModal && (
        <ViewLyveModal
          onModal={() => onModal("edit")}
          data={selectRow}
          onChangePartNumber={(part_number: string) =>
            onChangePartNumber(part_number)
          }
          updatedKey={updatedKey}
          originalOption={selectRow?.part_number || ""}
          duration={selectRow?.duration || 0}
          type={type}
        />
      )}
    </>
  );
}
